module.exports = __webpack_public_path__ + "static/img/researchInstitutes3.c1ff6bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Parters/researchInstitutes3.png
// module id = Cd/m
// module chunks = 1